import { useCredits } from '../lib/content';
import { IconExternal } from '../components/Icon';

/**
 * Credits — a gift to the vendors as much as information for guests, so it
 * reads as thanks rather than as a directory.
 */
export default function Credits() {
  const { data, error } = useCredits();

  if (!data) {
    return (
      <div className="page page-pad">
        {error ? <p style={{ opacity: 0.6, marginTop: 24 }}>The credits didn't load. They're worth waiting for — try again in a moment.</p> : null}
      </div>
    );
  }

  return (
    <div className="page page-narrow page-narrow-lg">
      <div className="page-pad" style={{ paddingTop: 20 }}>
        <h2 style={{ margin: '0 0 10px' }}>Thank you</h2>
        <p style={{ fontSize: 14, opacity: 0.8, textWrap: 'pretty' }}>{data.thanks}</p>
      </div>

      {data.groups.map((group) => (
        <section key={group.role} style={{ marginTop: 8 }}>
          <div className="day-head"><h4>{group.role}</h4></div>
          <div className="credits-group">
            {group.people.map((person) => (
              <div key={person.name} className="card credit">
                {person.photoUrl
                  ? <img src={person.photoUrl} alt={person.name} />
                  /* No portrait: initials, not a generated abstract that reads
                     as a photo of someone who never sat for one. */
                  : <span className="ph" aria-hidden="true">{initials(person.name)}</span>}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="credit-name">{person.name}</div>
                  <div className="credit-role">{person.title}</div>
                  {person.line && <div className="credit-line">{person.line}</div>}
                  {person.handle && (
                    <a
                      href={`https://instagram.com/${person.handle.replace('@', '')}`}
                      target="_blank" rel="noreferrer noopener"
                      style={{ fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 5, marginTop: 4 }}
                    >
                      {person.handle} <IconExternal size={12} />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

/** "Olive Restaurant & Garden" → "OR", "Meg" → "M". */
function initials(name: string): string {
  return name.split(/\s+/).filter((w) => /^[A-Za-z]/.test(w)).slice(0, 2).map((w) => w[0]!.toUpperCase()).join('');
}
